"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ModalHeader = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _FormattedMessage2, _Illustration, _FormattedMessage3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CheckEmail = _ref => {
  let {
    email,
    reason
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader.default, {
      title: reason === "signUpConfirmation" ? _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.sign_up_confirmation.title"
      })) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.check_email"
      })),
      illustration: _Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
        name: "Mailbox",
        size: "small"
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-CheckEmail",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        children: [reason === "magicLink" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.check_email_magic_link",
          values: {
            email,
            ref: text => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              as: "span",
              weight: "bold",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "break-words",
                children: text
              })
            })
          }
        }), reason === "signUpConfirmation" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.sign_up_confirmation.description",
          values: {
            email,
            ref: text => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              as: "span",
              weight: "bold",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "break-words",
                children: text
              })
            })
          }
        }), reason === "resetPassword" && (_FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.you_will_recieve_password"
        })))]
      })
    })]
  });
};
var _default = exports.default = CheckEmail;